import { t as u } from "./l10n-1b905a9a.mjs";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 * @author Grigorii K. Shartsev <me@shgk.me>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class l {
  /**
   * @param {number} r The red value
   * @param {number} g The green value
   * @param {number} b The blue value
   * @param {string} [name] The name of the color
   */
  constructor(t, n, r, c) {
    this.r = t, this.g = n, this.b = r, c && (this.name = c);
  }
}
function b(o, t) {
  const n = new Array(3);
  return n[0] = (t[1].r - t[0].r) / o, n[1] = (t[1].g - t[0].g) / o, n[2] = (t[1].b - t[0].b) / o, n;
}
function i(o, t, n) {
  const r = [];
  r.push(t);
  const c = b(o, [t, n]);
  for (let e = 1; e < o; e++) {
    const a = Math.floor(t.r + c[0] * e), f = Math.floor(t.g + c[1] * e), h = Math.floor(t.b + c[2] * e);
    r.push(new l(a, f, h));
  }
  return r;
}
function w(o) {
  o || (o = 6);
  const t = new l(182, 70, 157, u("Purple")), n = new l(221, 203, 85, u("Gold")), r = new l(0, 130, 201, u("Nextcloud blue")), c = i(o, t, n), e = i(o, n, r), a = i(o, r, t);
  return c.concat(e).concat(a);
}
export {
  w as G
};
